// Clears all locally-stored auth/session state on logout, including MSAL's
// own cached account/tokens (msalConfig.js uses cacheLocation: 'sessionStorage').
// Without clearing that too, an SSO-authenticated session lingers after
// "logout" and can silently resume on the next visit to /login.
export function clearAuthStorage() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('financial_year');
  localStorage.removeItem('financial_half');
  localStorage.removeItem('audit_type');
  localStorage.removeItem('applications');
  sessionStorage.clear();
}

// Logs the user out and lands them back on /login via a full browser
// navigation (not React Router's client-side navigate). This is required for
// SSO sessions: MSAL's handleRedirectPromise() caches its resolved response
// in memory for the lifetime of the PublicClientApplication instance, so a
// client-side-only route change back to /login would silently replay the
// same cached SSO response and re-log the user in. A real page load
// reinitializes MSAL fresh, with no leftover in-memory state.
export function logout() {
  clearAuthStorage();
  const basename = (process.env.REACT_APP_BASENAME || '/').replace(/\/+$/, '');
  window.location.href = `${basename}/login`;
}
